exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animate-trigger{opacity:0;-webkit-transform:translateY(100px);transform:translateY(100px);-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.animate-trigger.has-entered{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}", ""]);

// exports
